import React, {Component} from 'react'
import { connect } from 'react-redux'
import { Modal, TransitionablePortal, Form, TextArea, Confirm, Button } from 'semantic-ui-react'
import { requestJoinCsa, resetJoinCsaRequest } from '../../store/actions/athleteActions'

const initialState = {
    parentFirstName: '',
    parentFirstNameChanged: false,
    parentLastName: '',
    parentLastNameChanged: false,
    parentEmail: '',
    parentEmailChanged: false,
    parentPhoneNumber: '',
    parentPhoneNumberChanged: false,
    athleteFirstName: '',
    athleteFirstNameChanged: false,
    athleteLastName: '',
    athleteLastNameChanged: false,
    athleteGradYear: '',
    athleteGradYearChanged: false,
    athleteSport: '',
    athleteSportChanged: false,
    athleteState: '',
    athleteStateChanged: false,
    formComments: '',
    formCommentsChanged: false,
    changesMade: false,
    confirmOpen: false,
    tryingToSend: false
}

class JoinCsaForm extends Component {

    constructor(props) {
        super(props)

        this.state = initialState
    }

    handleSubmit = (e) => {
        e.preventDefault()

        this.setState({

            tryingToSend: true
            
        }, () => {

            this.props.requestJoinCsa(this.state)
        })
    }

    trackChanges = () => {

        if (this.state.parentFirstNameChanged || this.state.parentLastNameChanged || this.state.parentEmailChanged ||
            this.state.parentPhoneNumberChanged || this.state.athleteFirstNameChanged || this.state.athleteLastNameChanged ||
            this.state.athleteGradYearChanged || this.state.athleteSportChanged || this.state.athleteStateChanged ||
            this.state.formCommentsChanged) {

                this.setState({
                    changesMade: true
                })
        } else {
            this.setState({
                changesMade: false
            })
        }
    }

    
    handleChange = (e) => {

        this.setState({
            [e.target.id]: e.target.value
        })

        this.setState({
            [e.target.id]: e.target.value
        }, () => {

            switch(e.target.id) {
                case 'parentFirstName':
                    if (e.target.value !== '') {
                        this.setState({
                            parentFirstNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            parentFirstNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'parentLastName':
                    if (e.target.value !== '') {
                        this.setState({
                            parentLastNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            parentLastNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'parentEmail':
                    if (e.target.value !== '') {
                        this.setState({
                            parentEmailChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            parentEmailChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'parentPhoneNumber':
                    if (e.target.value !== '') {
                        this.setState({
                            parentPhoneNumberChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            parentPhoneNumberChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'athleteFirstName':
                    if (e.target.value !== '') {
                        this.setState({
                            athleteFirstNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            athleteFirstNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'athleteLastName':
                    if (e.target.value !== '') {
                        this.setState({
                            athleteLastNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            athleteLastNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'athleteGradYear':
                    if (e.target.value !== '') {
                        this.setState({
                            athleteGradYearChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            athleteGradYearChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'athleteSport':
                    if (e.target.value !== '') {
                        this.setState({
                            athleteSportChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            athleteSportChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'athleteState':
                    if (e.target.value !== '') {
                        this.setState({
                            athleteStateChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            athleteStateChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'formComments':
                    if (e.target.value !== '') {
                        this.setState({
                            formCommentsChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            formCommentsChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
            default:
                return
              }
        })
    }

    handleClose = () => {

        if (this.state.changesMade) {
            this.confirmOpen()
        } else {
            this.props.joinCsaClose()
        }
    }

    handleExit = () => {

        this.setState(initialState, () => {

            this.props.resetJoinCsaRequest()

            this.props.joinCsaClose()
        })
    }

    confirmOpen = () => this.setState({ confirmOpen: true })

    confirmClose = () => {
        this.setState(initialState, () => {

            this.handleClose()
        })
    }

    confirmCloseCancel = () => {
        this.setState({
            confirmOpen: false
        })
    }

    render () {

        const {joinCsaRequestSent} = this.props

        const animation = 'scale'
        const duration = 500

        var saveButton = null
        var infoRequestStatus = null

        const formParentFirstName = <input placeholder='First Name' id='parentFirstName' value={this.state.parentFirstName} onChange={this.handleChange} />
        const formParentLastName = <input placeholder='Last Name' id='parentLastName' value={this.state.parentLastName} onChange={this.handleChange} />
        const formParentEmail = <input placeholder='Email' id='parentEmail' value={this.state.parentEmail} onChange={this.handleChange} />
        const formParentPhoneNumber = <input placeholder='Phone' id='parentPhoneNumber' value={this.state.parentPhoneNumber} onChange={this.handleChange} />
        const formAthleteFirstName = <input placeholder='First Name' id='athleteFirstName' value={this.state.athleteFirstName} onChange={this.handleChange} />
        const formAthleteLastName = <input placeholder='Last Name' id='athleteLastName' value={this.state.athleteLastName} onChange={this.handleChange} />
        const formAthleteGradYear = <input placeholder='2025' id='athleteGradYear' value={this.state.athleteGradYear} onChange={this.handleChange} />
        const formAthleteSport = <input placeholder='Softball' id='athleteSport' value={this.state.athleteSport} onChange={this.handleChange} />
        const formAthleteState = <input placeholder='Texas' id='athleteState' value={this.state.athleteState} onChange={this.handleChange} />
        const formComments = <TextArea placeholder='Additional Comments' id='formComments' value={this.state.formComments} onChange={this.handleChange}/>

        if (this.state.parentFirstName !== '' && this.state.parentLastName !== '' && this.state.parentEmail !== '' &&
        this.state.parentPhoneNumber !== '' && this.state.athleteFirstName !== '' && this.state.athleteLastName !== '' &&
        this.state.athleteGradYear !== '' && this.state.athleteSport !== '' && this.state.athleteState !== '' &&
        !this.state.tryingToSend) {

            saveButton = <Button
            floated='right'
            positive
            name="saveButton"
            content="Submit"
            labelPosition='right'
            icon='paper plane'
            onClick={this.handleSubmit}
            />
        } else {

            if (this.state.tryingToSend) {
                saveButton = <Button
                disabled
                loading
                floated='right'
                positive
                name="saveButton"
                content="Submit"
                labelPosition='right'
                icon='paper plane'
                onClick={this.handleSubmit}
                />

            } else {
                saveButton = <Button
                disabled
                floated='right'
                positive
                name="saveButton"
                content="Submit"
                labelPosition='right'
                icon='paper plane'
                onClick={this.handleSubmit}
                />
            }
        }

        if (joinCsaRequestSent) {
            infoRequestStatus =
            <TransitionablePortal
                transition={{animation, duration}}
                open={joinCsaRequestSent}
                onClose= {this.handleExit}
            >
                <Modal
                    onClose= {this.handleExit}
                    open={true}
                >
                    <Modal.Content>
                        <div className="AdminProfileUpdatedContainer">
                            <h3>Thank You! - We'll Contact You Soon!</h3>
                            <Button
                                positive
                                name="okButton"
                                content="OK"
                                onClick= {this.handleExit} 
                            />
                        </div>
                    </Modal.Content>
                </Modal>
            </TransitionablePortal>
    }

        const athleteRequestForm =
                <div className="AdminFormContainer">
                    <Form >
                        <div className="AdminFormPersonalInfoContainer">
                            <h3>Contact CSA:</h3>
                            <Form.Field required>
                                <label>Parent Email</label>
                                {formParentEmail}
                            </Form.Field>
                            <Form.Field required>
                                <label>Parent First Name</label>
                                {formParentFirstName}
                            </Form.Field>
                            <Form.Field required>
                                <label>Parent Last Name</label>
                                {formParentLastName}
                            </Form.Field>
                            <Form.Field required>
                                <label>Parent Phone Number</label>
                                {formParentPhoneNumber}
                            </Form.Field>
                            <Form.Field required>
                                <label>Student Athlete First Name</label>
                                {formAthleteFirstName}
                            </Form.Field>
                            <Form.Field required>
                                <label>Student Athlete Last Name</label>
                                {formAthleteLastName}
                            </Form.Field>
                            <Form.Field required>
                                <label>High School Graduation Year</label>
                                {formAthleteGradYear}
                            </Form.Field>
                            <Form.Field required>
                                <label>Student Athlete's Desired Sport in College</label>
                                {formAthleteSport}
                            </Form.Field>
                            <Form.Field required>
                                <label>What State Do You Live In?</label>
                                {formAthleteState}
                            </Form.Field>
                            <Form.Field>
                                <label>Comments</label>
                                {formComments}
                            </Form.Field>
                        </div>
                        {infoRequestStatus}
                    </Form>
                </div>

        return (
            <TransitionablePortal
                        transition={{animation, duration}}
                        open={this.props.joinCsa}
                        onClose={() => this.handleClose()}
                    >
                        <Modal
                            onClose={() => this.handleClose()}
                            open={true}
                            >
                            <Modal.Content scrolling>
                                <div className="AdminTopButtonsProgressContainer">
                                    <div className="AdminTopButtonsContainer">
                                        <Button
                                            floated='left'
                                            circular
                                            icon='close'
                                            onClick={() => this.handleClose()}
                                        />
                                        {saveButton}
                                    </div>
                                </div>
                                {athleteRequestForm}
                                <Confirm
                                    open={this.state.confirmOpen}
                                    content='You have unsaved changes.  Are you sure you want to exit?'
                                    onCancel={this.confirmCloseCancel}
                                    onConfirm={this.confirmClose}
                                />
                            </Modal.Content>
                        </Modal>
                    </TransitionablePortal>
        )  
    }
}

const mapStateToProps = (state) => {

    return {
        joinCsaRequestError: state.athlete.joinCsaRequestError,
        joinCsaRequestSent: state.athlete.joinCsaRequestSent
    }
  }

const mapDispatchToProps = (dispatch) => {
    return {
        requestJoinCsa: (requestInfo) => dispatch(requestJoinCsa(requestInfo)),
        resetJoinCsaRequest: () => dispatch(resetJoinCsaRequest())
    }
  }

export default connect (mapStateToProps, mapDispatchToProps) (JoinCsaForm)